import {
  USER_DATA,
  USER_DATA_SUCCESS,
  USER_DATA_FAIL,
  GET_LIST_VAI_TRO,
  GET_LIST_VAI_TRO_SUCCESS,
  GET_LIST_VAI_TRO_FAIL
} from 'constants/ActionTypes';

//Saga effects
import {
  put,
  takeEvery,
  takeLatest
} from 'redux-saga/effects';
import {
  getInfo
} from './Api';

// Get current info
const getInfoMe = function* getInfoMe() {
  try {
    const receivedData = yield getInfo.getMeInfo();
    yield put({
      type: USER_DATA_SUCCESS,
      data: receivedData.data,
      status: receivedData.status
    });
  } catch (error) {
    yield put({
      type: USER_DATA_FAIL,
      error
    });
  }
};

export const watchGetInfoMe = function* watchGetInfoMe() {
  yield takeEvery(USER_DATA, getInfoMe);
};

// Get list Vai trò
const getListVaiTro = function* getListVaiTro() {
  try {
    const receivedData = yield getInfo.getListVaiTro();
    yield put({
      type: GET_LIST_VAI_TRO_SUCCESS,
      data: receivedData.data,
      status: receivedData.status
    });
  } catch (error) {
    yield put({
      type: GET_LIST_VAI_TRO_FAIL,
      error
    });
  }
};

export const watchGetListVaiTro = function* watchGetListVaiTro() {
  yield takeLatest(GET_LIST_VAI_TRO, getListVaiTro);
};
